import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./olo_set_table_number_as.js";
//#region src/olo_set_table_number_as_helper.ts
var olo_set_table_number_as_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(setTableNumberAs) {
	switch (setTableNumberAs) {
		case "table-number": return "Table Number";
		case "order-number": return "Order Number";
	}
}
//#endregion
export { name, olo_set_table_number_as_helper_exports };

//# sourceMappingURL=olo_set_table_number_as_helper.js.map